import * as ambassadorWixMarketingMarketingConsentV1MarketingConsent from './marketing-marketing-consent-v1-marketing-consent-marketing-consent.http.js';
import * as ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes from './marketing-marketing-consent-v1-marketing-consent-marketing-consent.types.js';
import * as ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes from './marketing-marketing-consent-v1-marketing-consent-marketing-consent.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getMarketingConsent(): __PublicMethodMetaInfo<
  'GET',
  { marketingConsentId: string },
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.GetMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.GetMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.GetMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.GetMarketingConsentResponse
> {
  const payload = { marketingConsentId: ':marketingConsentId' } as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.getMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/marketing-consent/{marketingConsentId}',
    pathParams: { marketingConsentId: 'marketingConsentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMarketingConsentByIdentifier(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.GetMarketingConsentByIdentifierRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.GetMarketingConsentByIdentifierRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.GetMarketingConsentByIdentifierResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.GetMarketingConsentByIdentifierResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.getMarketingConsentByIdentifier(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/marketing-consent/get-by',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createMarketingConsent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.CreateMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.CreateMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.CreateMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.CreateMarketingConsentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.createMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/marketing-consent',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMarketingConsent(): __PublicMethodMetaInfo<
  'PATCH',
  { marketingConsentId: string },
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.UpdateMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.UpdateMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.UpdateMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.UpdateMarketingConsentResponse
> {
  const payload = { marketingConsent: { id: ':marketingConsentId' } } as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.updateMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/marketing-consent/{marketingConsent.id}',
    pathParams: { marketingConsentId: 'marketingConsentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteMarketingConsent(): __PublicMethodMetaInfo<
  'DELETE',
  { marketingConsentId: string },
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.DeleteMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.DeleteMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.DeleteMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.DeleteMarketingConsentResponse
> {
  const payload = { marketingConsentId: ':marketingConsentId' } as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.deleteMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/marketing-consent/{marketingConsentId}',
    pathParams: { marketingConsentId: 'marketingConsentId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeMarketingConsent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.RemoveMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.RemoveMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.RemoveMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.RemoveMarketingConsentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.removeMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/marketing-consent/remove',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMarketingConsent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.QueryMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.QueryMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.QueryMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.QueryMarketingConsentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.queryMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/marketing-consent/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function upsertMarketingConsent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.UpsertMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.UpsertMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.UpsertMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.UpsertMarketingConsentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.upsertMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/marketing-consent/upsert',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpsertMarketingConsent(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.BulkUpsertMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.BulkUpsertMarketingConsentRequest,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentUniversalTypes.BulkUpsertMarketingConsentResponse,
  ambassadorWixMarketingMarketingConsentV1MarketingConsentTypes.BulkUpsertMarketingConsentResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMarketingMarketingConsentV1MarketingConsent.bulkUpsertMarketingConsent(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/marketing-consent/upsert',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MarketingConsent as MarketingConsentOriginal,
  MarketingConsentDetails as MarketingConsentDetailsOriginal,
  MarketingConsentDetailsIdentifierOneOf as MarketingConsentDetailsIdentifierOneOfOriginal,
  MarketingConsentDetailsIdentifierType as MarketingConsentDetailsIdentifierTypeOriginal,
  MarketingConsentDetailsIdentifierTypeWithLiterals as MarketingConsentDetailsIdentifierTypeWithLiteralsOriginal,
  MarketingConsentState as MarketingConsentStateOriginal,
  MarketingConsentStateWithLiterals as MarketingConsentStateWithLiteralsOriginal,
  LastConfirmationActivity as LastConfirmationActivityOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  OptInLevel as OptInLevelOriginal,
  OptInLevelWithLiterals as OptInLevelWithLiteralsOriginal,
  LastRevokeActivity as LastRevokeActivityOriginal,
  LastRevokeActivitySource as LastRevokeActivitySourceOriginal,
  LastRevokeActivitySourceWithLiterals as LastRevokeActivitySourceWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  GetMarketingConsentRequest as GetMarketingConsentRequestOriginal,
  GetMarketingConsentResponse as GetMarketingConsentResponseOriginal,
  GetMarketingConsentByIdentifierRequest as GetMarketingConsentByIdentifierRequestOriginal,
  GetMarketingConsentByIdentifierRequestIdentifierOneOf as GetMarketingConsentByIdentifierRequestIdentifierOneOfOriginal,
  GetMarketingConsentByIdentifierResponse as GetMarketingConsentByIdentifierResponseOriginal,
  CommunicationEligibility as CommunicationEligibilityOriginal,
  GetConsistentMarketingConsentByIdentifierRequest as GetConsistentMarketingConsentByIdentifierRequestOriginal,
  GetConsistentMarketingConsentByIdentifierRequestIdentifierOneOf as GetConsistentMarketingConsentByIdentifierRequestIdentifierOneOfOriginal,
  GetConsistentMarketingConsentByIdentifierResponse as GetConsistentMarketingConsentByIdentifierResponseOriginal,
  CreateMarketingConsentRequest as CreateMarketingConsentRequestOriginal,
  CreateMarketingConsentResponse as CreateMarketingConsentResponseOriginal,
  Link as LinkOriginal,
  LinkType as LinkTypeOriginal,
  LinkTypeWithLiterals as LinkTypeWithLiteralsOriginal,
  UpdateMarketingConsentRequest as UpdateMarketingConsentRequestOriginal,
  UpdateMarketingConsentResponse as UpdateMarketingConsentResponseOriginal,
  DeleteMarketingConsentRequest as DeleteMarketingConsentRequestOriginal,
  DeleteMarketingConsentResponse as DeleteMarketingConsentResponseOriginal,
  RemoveMarketingConsentRequest as RemoveMarketingConsentRequestOriginal,
  RemoveMarketingConsentResponse as RemoveMarketingConsentResponseOriginal,
  CreateMarketingConsentByTokenRequest as CreateMarketingConsentByTokenRequestOriginal,
  CreateMarketingConsentByTokenResponse as CreateMarketingConsentByTokenResponseOriginal,
  RemoveMarketingConsentByTokenRequest as RemoveMarketingConsentByTokenRequestOriginal,
  RemoveMarketingConsentByTokenResponse as RemoveMarketingConsentByTokenResponseOriginal,
  QueryMarketingConsentRequest as QueryMarketingConsentRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryMarketingConsentResponse as QueryMarketingConsentResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpsertMarketingConsentRequest as UpsertMarketingConsentRequestOriginal,
  UpsertMarketingConsentResponse as UpsertMarketingConsentResponseOriginal,
  BulkUpsertMarketingConsentRequest as BulkUpsertMarketingConsentRequestOriginal,
  BulkUpsertMarketingConsentResponse as BulkUpsertMarketingConsentResponseOriginal,
  BulkUpsertMarketingConsentResult as BulkUpsertMarketingConsentResultOriginal,
  Metadata as MetadataOriginal,
  GenerateLinkRequest as GenerateLinkRequestOriginal,
  GenerateLinkRequestIdentifierOneOf as GenerateLinkRequestIdentifierOneOfOriginal,
  GenerateLinkResponse as GenerateLinkResponseOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './marketing-marketing-consent-v1-marketing-consent-marketing-consent.types.js';
